import { Tabs } from 'antd';

import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierList from '../components/lists/CarrierList';
import { useCarriers } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminCarriersPage = ({ disableLayout, routes }) => {
  const { allCarriers, inactiveCarriers } = useCarriers();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Carriers" />
      <Tabs
        defaultActiveKey="active"
        items={[
          {
            children: <CarrierList carriers={allCarriers} id="carriers" />,
            key: 'active',
            label: 'ACTIVE',
          },
          {
            children: (
              <CarrierList
                readOnly
                carriers={inactiveCarriers}
                id="carriers-inactive"
              />
            ),
            key: 'inactive',
            label: 'INACTIVE',
          },
        ]}
        tabBarStyle={{
          background: 'var(--bg-content)',
          marginBottom: 0,
          position: 'sticky',
          top: 50,
          zIndex: 10,
        }}
      />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminCarriersPage;
